import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #fff;
  padding: 0.75rem;

  div {
    max-width: 570px;
    border-radius: 0.5rem;
    background: #ff9000;
    padding: 2.5rem 2rem;
  }
`;

export const Twitch = () => {
  const location = useLocation();
  const clientIdFormatted = location.hash.substring(
    location.hash.indexOf('state=') + 6,
    location.hash.indexOf('&token'),
  );
  const tokenFormatted = location.hash.substring(
    location.hash.indexOf('=') + 1,
    location.hash.indexOf('&'),
  );

  return (
    <Container>
      <div>
        <h5 className="text-center">VALIDAÇÃO DE TOKEN FEITA COM SUCESSO!</h5>
        <p className="mt-4 mb-0">
          <strong className="mr-2">TOKEN:</strong>
          {tokenFormatted}
        </p>
      </div>
    </Container>
  );
};
